export const getHostReadyClass = (className: string, isReady: boolean): Record<string, boolean> => {
  return {
    [className]: true,
    '-ready': isReady,
  };
};

export const getWebcomponentRootFromElement = (hostElement: HTMLElement | undefined): Element | undefined => {
  if (!hostElement) {
    return;
  }

  const rootNode = hostElement.getRootNode({ composed: false });

  return (rootNode as ShadowRoot)?.host;
};
